module.exports = __webpack_public_path__ + "img/2023big27.f2b5b161.png";